class StatusEnum {
    constructor(descricao, value) {
      this.descricao = descricao;
      this.value = value;
    }

    static fromValue(value) {
      return Object.values(StatusEnum).find(status => status.value === value);
    }

    static fromDescricao(descricao) {
      return Object.values(StatusEnum).find(status => status.descricao === descricao);
    }
  }

  StatusEnum.EM_ANALISE = new StatusEnum("em análise", 84);
  StatusEnum.PC_APROVADO = new StatusEnum("aprovado", 85);
  StatusEnum.PC_REPROVADO = new StatusEnum("reprovado", 86);
  StatusEnum.EM_DIGITACAO = new StatusEnum("em digitação", 87);

  // Tarefa - Processo
  StatusEnum.TAREFA_AGUARDANDO = new StatusEnum("Aguardando", 127);
  StatusEnum.TAREFA_EM_ANDAMENTO = new StatusEnum("Em Andamento", 128);
  StatusEnum.TAREFA_FINALIZADA = new StatusEnum("Finalizado", 129);
  StatusEnum.TAREFA_EXPIRADO = new StatusEnum("Expirado", 218);

  // Status fictício que engloba 2 status
  StatusEnum.TAREFA_AGUARDANDO_EM_ANDAMENTO = new StatusEnum("TAREFA_AGUARDANDO_EM_ANDAMENTO", -1);

  // Processo
  StatusEnum.PROCESSO_EM_DIGITACAO = new StatusEnum("Em Digitação", 130);
  StatusEnum.PROCESSO_EM_ANDAMENTO = new StatusEnum("Em Andamento", 131);
  StatusEnum.PROCESSO_APROVADO = new StatusEnum("Aprovado", 133);
  StatusEnum.PROCESSO_REPROVADO = new StatusEnum("Reprovado", 134);
  StatusEnum.PROCESSO_FINALIZADO = new StatusEnum("Finalizado", 135);

  // Exercício Fiscal
  StatusEnum.EXERCICIO_EM_ABERTO = new StatusEnum("Em Aberto", 139);
  StatusEnum.EXERCICIO_FINALIZADO = new StatusEnum("Finalizado", 140);
  StatusEnum.EXERCICIO_CADASTRADO = new StatusEnum("Cadastrado", 141);

  // Solicitação de movimentação
  StatusEnum.SOLICITACAO_MOVIMENTACAO_FINALIZADO = new StatusEnum("Finalizado", 57);
  StatusEnum.SOLICITACAO_MOVIMENTACAO_CONCLUID_ADM = new StatusEnum("Concluído pelo Administrador", 250);

  // Baixa Item Bem Permanente (Processo)
  StatusEnum.PROCESSO_BAIXA_IBP_BAIXADO = new StatusEnum("Baixado", 142);
  StatusEnum.PROCESSO_BAIXA_IBP_ESTORNADO = new StatusEnum("Estornado", 143);
  StatusEnum.PROCESSO_BAIXA_IBP_ESTORNADO_PARCIALMENTE = new StatusEnum("Estornado Parcialmente", 144);
  StatusEnum.PROCESSO_BAIXA_IBP_EM_ANDAMENTO = new StatusEnum("Em Andamento", 225);

  // Baixa Item Bem Permanente (Item)
  StatusEnum.ITEM_BAIXA_IBP_BAIXADO = new StatusEnum("Baixado", 145);
  StatusEnum.ITEM_BAIXA_IBP_ESTORNADO = new StatusEnum("Estornado", 146);
  StatusEnum.ITEM_BAIXA_IBP_EM_ANDAMENTO = new StatusEnum("Em Andamento", 227);

  // Registro Entrada
  StatusEnum.EM_CONFERENCIA = new StatusEnum("Em Conferência", 147);
  StatusEnum.ATESTO = new StatusEnum("Atesto", 148);
  StatusEnum.ATESTANDO = new StatusEnum("Atestando", 219);

  // Baixa Item Bem Permanente (Processo)
  StatusEnum.PROCESSO_BAIXA_IBC_BAIXADO = new StatusEnum("Baixado", 149);
  StatusEnum.PROCESSO_BAIXA_IBC_ESTORNADO = new StatusEnum("Estornado", 152);
  StatusEnum.PROCESSO_BAIXA_IBC_ESTORNADO_PARCIALMENTE = new StatusEnum("Estornado Parcialmente", 153);

  // Baixa Item Bem Consumo (Item)
  StatusEnum.ITEM_BAIXA_IBC_BAIXADO = new StatusEnum("Baixado", 154);
  StatusEnum.ITEM_BAIXA_IBC_ESTORNADO = new StatusEnum("Estornado", 155);
  StatusEnum.ITEM_BAIXA_IBC_ESTORNADO_PARCIALMENTE = new StatusEnum("Estornado Parcialmente", 156);

  // Tarefa Solicitação Movimentação IBP
  StatusEnum.TAREFA_SOL_MOV_IBP_AGUARDANDO = new StatusEnum("Aguardando", 157);
  StatusEnum.TAREFA_SOL_MOV_IBP_EM_ANDAMENTO = new StatusEnum("Em Andamento", 158);
  StatusEnum.TAREFA_SOL_MOV_IBP_FINALIZADA = new StatusEnum("Finalizado", 159);
  StatusEnum.TAREFA_SOL_MOV_IBP_EXPIRADO = new StatusEnum("Expirado", 173);

  // Movimentação do item bem consumo
  StatusEnum.MOVIMENTACAO_IBC_EM_DIGITACAO = new StatusEnum("Em Digitação", 160);
  StatusEnum.MOVIMENTACAO_IBC_EM_ANDAMENTO = new StatusEnum("Em Andamento", 161);
  StatusEnum.MOVIMENTACAO_IBC_FINALIZADO = new StatusEnum("Finalizado", 162);

  // Item da movimentação do item bem consumo
  StatusEnum.ITEM_MOV_IBC_EM_ANDAMENTO = new StatusEnum("Em Andamento", 164);
  StatusEnum.ITEM_MOV_IBC_APROVADO_DESTINO = new StatusEnum("Aprovado Destino", 165);
  StatusEnum.ITEM_MOV_IBC_REPROVADO = new StatusEnum("Reprovado", 166);
  StatusEnum.ITEM_MOV_IBC_ESTORNADO = new StatusEnum("Estornado", 167);
  StatusEnum.ITEM_MOV_IBC_APROVADA_PARCIALMENTE_ORIGEM = new StatusEnum("Aprovado Parcialmente Origem", 171);
  StatusEnum.ITEM_MOV_IBC_ESTORNADO_PARCIALMENTE = new StatusEnum("Estornado Parcialmente", 172);
  StatusEnum.ITEM_MOV_IBC_APROVADO_ORIGEM = new StatusEnum("Aprovado Origem", 212);
  StatusEnum.ITEM_MOV_IBC_APROVADA_PARCIALMENTE_DESTINO = new StatusEnum("Aprovado Parcialmente Destino", 213);

  // Tarefa da solicitação de movimentação do ibc
  StatusEnum.TAREFA_MOV_IBC_AGUARDANDO = new StatusEnum("Aguardando", 168);
  StatusEnum.TAREFA_MOV_IBC_EM_ANDAMENTO = new StatusEnum("Em Andamento", 169);
  StatusEnum.TAREFA_MOV_IBC_FINALIZADA = new StatusEnum("Finalizado", 170);

  // Tarefa transferência de responsabilidade do IBP
  StatusEnum.TAREFA_TRANSF_RESP_IBP_FINALIZADA = new StatusEnum("Finalizado", 182);
  StatusEnum.TAREFA_TRANSF_RESP_IBP_APROVADO_ORIGEM = new StatusEnum("Aprovado pelo Setor de Origem", 185);
  StatusEnum.TAREFA_TRANSF_RESP_IBP_APROVADO_DESTINO = new StatusEnum("Aprovado pelo Setor de Destino", 186);
  StatusEnum.TAREFA_TRANSF_RESP_IBP_REPROVADO = new StatusEnum("Reprovado", 187);
  StatusEnum.TAREFA_TRANSF_RESP_IBP_APROVADO = new StatusEnum("Aprovado", 188);
  StatusEnum.TAREFA_TRANSF_RESP_IBP_AGUARDANDO = new StatusEnum("Aguardando", 189);
  StatusEnum.TAREFA_TRANSF_RESP_IBP_EM_ANDAMENTO = new StatusEnum("Em Andamento", 190);

  // Empenho
  StatusEnum.EMPENHO_EM_ANDAMENTO = new StatusEnum("Em Andamento", 180);
  StatusEnum.EMPENHO_CONCLUIDO = new StatusEnum("Concluído", 181);

  // Aprovado RFID
  StatusEnum.APROVADO_RFID = new StatusEnum("Aprovado RFID", 202);

  // Catalogo de Pedidos
  StatusEnum.PEDIDO_PRODUTO_CATALOGO_ANALISE= new StatusEnum("Em análise", 222),
  StatusEnum.PEDIDO_PRODUTO_CATALOGO_AGUARDANDO= new StatusEnum("Aguardando", 223),
  StatusEnum.PEDIDO_PRODUTO_CATALOGO_FINALIZADO=new StatusEnum ("Finalizado", 224),
  // Inventário
  StatusEnum.INVENTARIO_EM_DIGITACAO = new StatusEnum("Em Digitação", 206);
  StatusEnum.INVENTARIO_EM_ANDAMENTO = new StatusEnum("Em Andamento", 207);
  StatusEnum.INVENTARIO_FINALIZADO = new StatusEnum("Finalizado", 208);

  // Almoxarifado do inventário
  StatusEnum.INVENTARIOALMOXARIFADO_INVENTARIANDO = new StatusEnum("Inventariando", 210);
  StatusEnum.INVENTARIOALMOXARIFADO_FINALIZADO = new StatusEnum("Finalizando", 211);

  StatusEnum.IBP_ITEM_REGISTRADO = new StatusEnum("Registrado", 11);
  StatusEnum.IBP_ITEM_EMPRESTADO = new StatusEnum("Item emprestado", 214);
  StatusEnum.IBP_NAO_LOCALIZADO = new StatusEnum("Item não localizado", 215);
  StatusEnum.IBP_EM_MANUTENCAO = new StatusEnum("Em manutenção", 216);
  StatusEnum.IBP_LOCALIZADO = new StatusEnum("Localizado", 217);
  StatusEnum.IBP_AGREGADO = new StatusEnum("Agregado", 137);
  StatusEnum.IBP_DESAGREGADO = new StatusEnum("Desagregado", 138);

  // Status do Orçamento
  StatusEnum.ORCAMENTO_EM_ANDAMENTO = new StatusEnum("Em Andamento", 261);
  StatusEnum.ORCAMENTO_EM_APROVACAO = new StatusEnum("Em Aprovação", 262);
  StatusEnum.ORCAMENTO_APROVADO = new StatusEnum("Aprovado", 263);
  StatusEnum.ORCAMENTO_FINALIZADO = new StatusEnum("Finalizado", 264);
  StatusEnum.ORCAMENTO_VENCIDO = new StatusEnum("Vencido", 265);

  StatusEnum.PROPOSTA_ACEITA = new StatusEnum("ACEITO", 266);
  StatusEnum.PROPOSTA_RECUSADO = new StatusEnum("RECUSADO", 267);
  StatusEnum.PROPOSTA_EM_ANALISE = new StatusEnum("EM_ANALISE", 268);
  StatusEnum.EXPIRADO_EXPIRADO = new StatusEnum("EXPIRADO", 269);

  // Requisição de Compra
  StatusEnum.REQUISICAO_COMPRA_EM_ANDAMENTO = new StatusEnum("Aguardando Envio", 273);
  StatusEnum.REQUISICAO_COMPRA_APROVADO = new StatusEnum("Aprovado", 274);
  StatusEnum.REQUISICAO_COMPRA_REJEITADO = new StatusEnum("Rejeitado", 275);

  // Autorização de Compra
  StatusEnum.AUTORIZACAO_COMPRA_EM_ANDAMENTO = new StatusEnum("Em Andamento", 276);
  StatusEnum.AUTORIZACAO_COMPRA_APROVADO = new StatusEnum("Aprovado", 277);
  StatusEnum.AUTORIZACAO_COMPRA_REJEITADO = new StatusEnum("Rejeitado", 278);
  StatusEnum.AUTORIZACAO_COMPRA_FINALIZADO = new StatusEnum("Finalizado", 283);

  // Processo de Compra
  StatusEnum.PROCESSO_COMPRA_EM_ANDAMENTO = new StatusEnum("Em Andamento", 279);
  StatusEnum.PROCESSO_COMPRA_AGUARDANDO_APROVACAO = new StatusEnum("Aguardando Aprovação", 280);
  StatusEnum.PROCESSO_COMPRA_APROVADO = new StatusEnum("Aprovado", 281);
  StatusEnum.PROCESSO_COMPRA_REJEITADO = new StatusEnum("Rejeitado", 282);
  StatusEnum.PROCESSO_COMPRA_FINALIZADO = new StatusEnum("Finalizado", 284);

  export default StatusEnum;
